import React, { Children, forwardRef, isValidElement, cloneElement } from 'react';
import './ctagroup.stylesheet_1253qna.css';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import './inlinebuttongroup.stylesheet_189ry4v.css';
import { cx } from 'linaria';
import { useSmoothScroll } from '@uds/smooth-scroll';
import { cssTheme } from '@uds/theme-utils';
import { classNames as classNames$1 } from '@uds/typography';
import './button.stylesheet_1wk39fo.css';
import Transition from '@team-griffin/react-transition';
import { Size as Size$1, PulseLoader } from '@uds/penders';
import { Glyph } from '@uds/glyphs';
import './animate_yek5jk.css';
import './content.stylesheet_1ntlcg3.css';

const ctaWrapper = "c129kp3f";
const ctaGroupContainer = "ccwvlgl";
const classNames = {
  ctaWrapper,
  ctaGroupContainer
};

const CTAGroup = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/jsx("div", {
    className: classNames.ctaGroupContainer,
    children: Children.map(children, child => /*#__PURE__*/jsx("span", {
      className: classNames.ctaWrapper,
      children: child
    }))
  });
};
CTAGroup.displayName = 'CTAGroup';
var CTAGroup$1 = CTAGroup;

let Kind;
(function (Kind) {
  Kind["PRIMARY"] = "PRIMARY";
  Kind["SECONDARY"] = "SECONDARY";
  Kind["TERTIARY"] = "TERTIARY";
  Kind["HIGHLIGHT"] = "HIGHLIGHT";
  Kind["DETRIMENTAL"] = "DETRIMENTAL";
})(Kind || (Kind = {}));
let Size;
(function (Size) {
  Size["SM"] = "SM";
  Size["MD"] = "MD";
  Size["LG"] = "LG";
})(Size || (Size = {}));
let GlyphAlignment;
(function (GlyphAlignment) {
  GlyphAlignment["START"] = "START";
  GlyphAlignment["END"] = "END";
})(GlyphAlignment || (GlyphAlignment = {}));
let Status;
(function (Status) {
  Status["DEFAULT"] = "DEFAULT";
  Status["PENDING"] = "PENDING";
  Status["SUCCESS"] = "SUCCESS";
  Status["FAILURE"] = "FAILURE";
})(Status || (Status = {}));

const root$1 = "r1nta5tq";
const getClassNames$2 = () => ({
  root: root$1
});

const InlineButtonGroup = _ref => {
  let {
    children = []
  } = _ref;
  const classNames = getClassNames$2();
  const rootClass = React.Children.count(children) > 1 ? classNames.root : undefined;
  return /*#__PURE__*/jsx("div", {
    className: rootClass,
    children: children
  });
};
var InlineButtonGroup$1 = InlineButtonGroup;

const icon$1 = "i1kzvnzx";
const svgGlyphWrapper = "s1i4bdq2";
const root = "r1wxslgr";
const label = "lkfmov2";
const buttonSize = {
  SM: "s161hd3s",
  MD: "m5l3fb3",
  LG: "l18z8wav"
};
const withGlyph = {
  START: "s1wo5mrg",
  END: "e13hen0v"
};
const fullWidth = "f1fqb7n6";
const primary = "p8n7m4u";
const secondary = "sm7i3";
const tertiary = "t86uesf";
const highlight = "hz5ysm3";
const detrimental = "d1041vks";
const colorway = {
  PRIMARY: primary,
  SECONDARY: secondary,
  TERTIARY: tertiary,
  HIGHLIGHT: highlight,
  DETRIMENTAL: detrimental
};
const reactiveOpacity = {
  DEFAULT: "d1cd8yj0",
  SUCCESS: "s1gqj7mj",
  PENDING: "p1r4t4z",
  FAILURE: "fapbyvz"
};
const reactiveGlyph = {
  DEFAULT: "d1iguxr4",
  SUCCESS: "s1udtdhr",
  PENDING: "p1f2ffrt",
  FAILURE: "f1vbtks4"
};
const getClassNames$1 = _ref => {
  let {
    status = Status.DEFAULT,
    kind,
    size,
    block,
    glyph,
    glyphAlignment,
    children
  } = _ref;
  const hasGlyph = glyph != null && children != null;
  return {
    root: cx(root, size === Size.LG ? classNames$1.headingXs : classNames$1.headingXxs, size != null && buttonSize[size], kind != null && colorway[kind], block && fullWidth, hasGlyph && glyphAlignment != null && withGlyph[glyphAlignment], reactiveOpacity[status]),
    label,
    glyph: cx(icon$1, reactiveGlyph[Status.DEFAULT], reactiveGlyph[status]),
    svgGlyphWrapper
  };
};

const className = _ref => {
  let {
    entering,
    entered,
    leave
  } = _ref;
  return cx("cgxytjt", entering || entered || leave ? "c9y2g29" : "c1vpqblf");
};
const Animate = _ref2 => {
  let {
    children,
    entering,
    entered,
    leave
  } = _ref2;
  return /*#__PURE__*/jsx("span", {
    className: className({
      entering,
      entered,
      leave
    }),
    children: children
  });
};
var Animate$1 = Animate;

const icon = "i1iyn11o";
const iconContainer = "ihab9aw";
const text = "t15o6y26";
const textOpacity = {
  DEFAULT: "d1xl8y38",
  PENDING: "p1vjffvi",
  SUCCESS: "s1qa2wke",
  FAILURE: "fohausl"
};
const iconSize = {
  SM: "s1qbshdp",
  MD: "m1wzgsfc",
  LG: "l2l0aj7"
};
const loader = "ltp44ar";
const getAccentColor = _ref => {
  let {
    kind
  } = _ref;
  switch (kind) {
    case Kind.PRIMARY:
      return cssTheme.button.primary.text;
    case Kind.HIGHLIGHT:
      return cssTheme.button.highlight.text;
    case Kind.DETRIMENTAL:
      return cssTheme.button.detrimental.text;
    case Kind.SECONDARY:
      return cssTheme.button.secondary.text;
    case Kind.TERTIARY:
      return cssTheme.button.tertiary.text;
    default:
      return cssTheme.button.primary.text;
  }
};
const getClassNames = _ref2 => {
  let {
    status,
    size,
    withGlyph
  } = _ref2;
  return {
    loader,
    icon: cx(icon, iconSize[size]),
    text: cx(withGlyph && text, textOpacity[status]),
    iconContainer
  };
};

const loaderSizeMap = {
  [Size.SM]: Size$1.SMALL,
  [Size.MD]: Size$1.MEDIUM,
  [Size.LG]: Size$1.LARGE
};
const ReactiveButtonContent = _ref => {
  let {
    status,
    kind,
    children,
    size,
    withGlyph
  } = _ref;
  const classNames = getClassNames({
    size,
    status,
    withGlyph
  });
  const accentColor = getAccentColor({
    kind
  });
  const contentMap = {
    [Status.DEFAULT]: null,
    [Status.PENDING]: /*#__PURE__*/jsx(PulseLoader, {
      color: accentColor,
      size: loaderSizeMap[size]
    }, "pulseLoader"),
    [Status.SUCCESS]: /*#__PURE__*/jsx(Glyph, {
      name: "smallTick",
      className: classNames.icon
    }),
    [Status.FAILURE]: /*#__PURE__*/jsx(Glyph, {
      name: "smallCross",
      className: classNames.icon
    })
  };
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("span", {
      className: classNames.text,
      children: children
    }, "text"), /*#__PURE__*/jsx(Transition, {
      duration: 200,
      render: Animate$1,
      children: /*#__PURE__*/jsx("span", {
        className: classNames.iconContainer,
        children: contentMap[status]
      })
    })]
  });
};
ReactiveButtonContent.displayName = 'ReactiveButtonContent';
var Content = ReactiveButtonContent;

const ButtonContent = _ref => {
  let {
    children,
    className,
    kind,
    status,
    size,
    withGlyph
  } = _ref;
  if (children != null) {
    return /*#__PURE__*/jsx(Content, {
      status: status,
      kind: kind,
      size: size,
      withGlyph: withGlyph,
      children: /*#__PURE__*/jsx("span", {
        className: className,
        children: children
      })
    });
  }
  return null;
};
ButtonContent.displayName = 'ButtonContent';
const Button = /*#__PURE__*/forwardRef((_ref2, ref) => {
  let {
    kind = Kind.PRIMARY,
    size = Size.MD,
    status = Status.DEFAULT,
    block = false,
    disabled = false,
    type = 'button',
    href,
    children,
    className,
    glyph,
    glyphAlignment = GlyphAlignment.END,
    onClick,
    ...domProps
  } = _ref2;
  const classNames = getClassNames$1({
    status,
    kind,
    size,
    block,
    glyph,
    glyphAlignment,
    children
  });
  const isAnchor = href != null && href.charAt(0) === '#';
  const smoothScroll = useSmoothScroll();
  const isDisabled = disabled || [Status.PENDING, Status.SUCCESS, Status.FAILURE].includes(status);
  const handleClick = event => {
    if (isDisabled) {
      event.preventDefault();
    } else {
      if (isAnchor) {
        event.preventDefault();
        smoothScroll(href);
      }
      if (onClick) {
        onClick(event);
      }
    }
  };
  const props = {
    'className': cx(classNames.root, className),
    'ref': ref,
    'aria-disabled': isDisabled,
    'onClick': handleClick,
    ...(href == null ? null : {
      href
    }),
    ...domProps
  };
  const Component = href == null ? 'button' : 'a';
  const buttonType = href == null ? {
    type
  } : {};
  return /*#__PURE__*/jsxs(Component, {
    ...props,
    ...buttonType,
    children: [/*#__PURE__*/jsx(ButtonContent, {
      className: classNames.label,
      kind: kind,
      size: size,
      status: status,
      withGlyph: Boolean(glyph),
      children: children
    }), /*#__PURE__*/isValidElement(glyph) && /*#__PURE__*/jsx("span", {
      className: classNames.glyph,
      children: /*#__PURE__*/cloneElement(glyph, {
        size: cssTheme.gu3,
        className: classNames.svgGlyphWrapper
      })
    })]
  });
});
Button.displayName = 'Button';
var Button$1 = Button;

export { Button$1 as Button, CTAGroup$1 as CTAGroup, GlyphAlignment, InlineButtonGroup$1 as InlineButtonGroup, Kind, Size, Status, Button$1 as default };
